import React, { useState } from "react";

export default function UserSettings() {
  const [form, setForm] = useState({
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
    darkMode: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (form.password !== form.confirmPassword) {
      alert("Passwords do not match!");
      return;
    }

    console.log("Saved settings:", form);
    alert("Settings saved!");
  };

  return (
    <div style={styles.container}>
      <h2>User Settings</h2>

      <form onSubmit={handleSubmit} style={styles.form}>
        <label>Username</label>
        <input
          type="text"
          name="username"
          value={form.username}
          onChange={handleChange}
          style={styles.input}
        />

        <label>Email</label>
        <input
          type="email"
          name="email"
          value={form.email}
          onChange={handleChange}
          style={styles.input}
        />

        <label>New Password</label>
        <input
          type="password"
          name="password"
          value={form.password}
          onChange={handleChange}
          style={styles.input}
        />

        <label>Confirm Password</label>
        <input
          type="password"
          name="confirmPassword"
          value={form.confirmPassword}
          onChange={handleChange}
          style={styles.input}
        />

        <div style={styles.checkboxContainer}>
          <input
            type="checkbox"
            name="darkMode"
            checked={form.darkMode}
            onChange={handleChange}
          />
          <label>Enable Dark Mode</label>
        </div>

        <button type="submit" style={styles.button}>
          Save Settings
        </button>
      </form>
    </div>
  );
}

const styles = {
  container: {
    maxWidth: "400px",
    margin: "50px auto",
    padding: "20px",
    borderRadius: "10px",
    background: "#1e1e1e",
    color: "#fff",
  },
  form: {
    display: "flex",
    flexDirection: "column",
  },
  input: {
    marginBottom: "10px",
    padding: "8px",
    borderRadius: "5px",
    border: "none",
  },
  checkboxContainer: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginBottom: "15px",
  },
  button: {
    padding: "10px",
    borderRadius: "5px",
    border: "none",
    background: "#4CAF50",
    color: "#fff",
    cursor: "pointer",
  },
};